// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2HNAq","loaderOuter":"PageOverlayLoader_loaderOuter__bxlEF"};